<template lang="pug">
  v-container
    v-row
      v-col(
        class="py-0"
        cols="12"
      )
        v-text-field(
          label="Stock Code"
          :value="id"
          readonly
          dense
          outlined
          :error-messages="errorMessages.id || []"
        )
      v-col(class="py-0" cols="12" lg="6")
        //- slot(
        //-   name="stockCategory"
        //- )
        v-text-field(
          outlined
          dense
          label="Stock Category"
          :value="stockCategoryId"
          disabled
        )
      v-col(class="py-0" cols="12" lg="6")
        v-text-field(
          label="Product Name"
          v-model="productName"
          :error-messages="errorMessages.product_name || []"
          outlined
          dense
        )
      v-col(class="py-0" cols="12" lg="6")
        v-text-field(
          label="Brand Name"
          v-model="brandName"
          :error-messages="errorMessages.brand_name || []"
          outlined
          dense
        )
      v-col(class="py-0" cols="12" lg="6")
        v-text-field(
          label="Product Type"
          v-model="productType"
          :error-messages="errorMessages.product_type || []"
          outlined
          dense
        )

      v-col(class="py-0" cols="12")
        v-text-field(
          label="Description"
          v-model="description"
          :error-messages="errorMessages.description || []"
          outlined
          dense
        )
</template>
<script>
const inputVars = () => ({
  id: null,
  stockCategoryId: null,
  productName: null,
  productType: null,
  brandName: null,
  description: null,
})

export default {
  name: 'StockForm',
  props: {
    inputFields: {
      type: Object,
      default: inputVars,
    },
    defaultFieldValues: {
      type: Object,
      default: inputVars,
    },
    errorMessages: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    ...inputVars(),
  }),
  watch: {
    defaultFieldValues(item) {
      const data = this.$objectChangeKeyCase(item)
      this.populateFields(data)
    },
    id() {
      this.updateInputFields()
    },
    stockCategoryId() {
      this.updateInputFields()
    },
    productName() {
      this.updateInputFields()
    },
    productType() {
      this.updateInputFields()
    },
    brandName(item) {
      this.updateInputFields()
    },
    description() {
      this.updateInputFields()
    },
  },
  methods: {
    updateInputFields(key) {
      const fieldValues = this.getFieldValues()
      this.$emit('update:inputFields', fieldValues)
    },
    populateFields(item) {
      const defaults = inputVars()
      Object.keys(defaults).forEach(key => {
        this[key] = item[key]
      })
    },
    getFieldValues() {
      const defaults = inputVars()
      return Object.keys(defaults)
        .reduce((result, key) => {
          result[key] = this[key]
          return result
        }, {})
    },
  },
}
</script>
